import script from "./TrainingUsersList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingUsersList.vue?vue&type=script&setup=true&lang=js"

import "./TrainingUsersList.vue?vue&type=style&index=0&id=1a51acb7&lang=scss"

const __exports__ = script;

export default __exports__